<template>
  <div>
    <cv-file-uploader
      v-model="uploadedFiles"
      kind="drag-target"
      accept=".zip"
      :clear-on-reselect="true"
      :initial-state-uploading="false"
      :multiple="false"
      :removable="true"
    >
      <template slot="drop-target">
        <div class="drop-target">
          <CloudUpload24 class="drop-target-icon" />
          Drop a zip file here (or click to browse)
        </div>
      </template>
    </cv-file-uploader>
    <cv-button
      class="upload-button"
      :icon="ArrowRight24"
      :disabled="!selectedFile || isUploading"
      @click="upload"
    >
      {{ isUploading ? "Uploading..." : "Scan zip" }}
    </cv-button>
  </div>
</template>

<script>
import { model, ErrorStatus } from "@/model.js";
import { uploadAndScan } from "@/helpers";
import { ArrowRight24, CloudUpload24 } from "@carbon/icons-vue";

export default {
  name: "SourceZipUploader",
  components: {
    CloudUpload24,
  },
  data() {
    return {
      ArrowRight24,
      uploadedFiles: [],
      isUploading: false,
    };
  },
  computed: {
    selectedFile() {
      // If a second file is dropped, the newest one is used
      const latest = this.uploadedFiles[this.uploadedFiles.length - 1];
      return latest ? latest.file : null;
    },
  },
  methods: {
    async upload() {
      this.isUploading = true;
      try {
        await uploadAndScan(this.selectedFile);
      } catch (error) {
        model.addError(ErrorStatus.SourceUpload, error.message);
      } finally {
        this.isUploading = false;
      }
    },
  },
};
</script>

<style scoped>
.drop-target {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px;
}
.drop-target-icon {
  margin-right: 8px;
}
.upload-button {
  margin-top: 8px;
}
</style>
